<div class="dialog-header" mat-dialog-title>
    <div class="dialog-title">{{ dialogTitle }} {{ codaltModusService.enabled() ? '- ' + planning.id : '' }}</div>
    <button (click)="close()" mat-icon-button aria-label="Sluiten">
        <mat-icon class="fa-solid fa-xmark-large"></mat-icon>
    </button>
</div>
<div class="dialog-content" mat-dialog-content>
    @if (!planningList) {
        <div class="form">Aan het laden...</div>
    } @else if (planningList) {
        <div class="form">
            <div class="top-form" [class.cutter]="viewModel.cutter" [class.wipetruck]="viewModel.wipetruck">
                @if (form) {
                    <form [formGroup]="form">
                        <div class="row">
                            <div [class.col-24]="!viewModel.sleepOrBlock" [class.col-16]="viewModel.sleepOrBlock">
                                <div class="form-line">
                                    @if (
                                        ![PlanningStatus.PlanningDefinitief, PlanningStatus.PlanningBevestigd].includes(
                                            initialStatus
                                        )
                                    ) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>Status</mat-label>
                                            <mat-select formControlName="status_key" placeholder="Status">
                                                @for (status of statusList; track status) {
                                                    <mat-option
                                                        [value]="status.key"
                                                        [disabled]="
                                                            (viewModel.fixedStatusDisabled &&
                                                                [
                                                                    PlanningStatus.PlanningReservering,
                                                                    PlanningStatus.PlanningGepland,
                                                                ].includes(status.key)) ||
                                                            (planning.id &&
                                                                ((status.key === PlanningStatus.PlanningSlaapdag &&
                                                                    planning.status_key !==
                                                                        PlanningStatus.PlanningSlaapdag) ||
                                                                    (status.key !== PlanningStatus.PlanningSlaapdag &&
                                                                        planning.status_key ===
                                                                            PlanningStatus.PlanningSlaapdag)))
                                                        ">
                                                        {{ status.name }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            <mat-error [control]="form.get('status_key')"></mat-error>
                                        </mat-form-field>
                                    }
                                    @if (
                                        [PlanningStatus.PlanningDefinitief, PlanningStatus.PlanningBevestigd].includes(
                                            initialStatus
                                        ) &&
                                        (mayBackToConcept || mayChangeFinalStatus)
                                    ) {
                                        <div class="status-actions">
                                            <div class="status-actions-buttons">
                                                @if (mayBackToConcept) {
                                                    <button
                                                        class="status-button status-button-concept"
                                                        (click)="backToConcept()"
                                                        mat-raised-button>
                                                        Terug naar concept
                                                    </button>
                                                }
                                                @if (mayChangeFinalStatus) {
                                                    @if (initialStatus === PlanningStatus.PlanningDefinitief) {
                                                        <button
                                                            class="status-button status-button-bevestigd"
                                                            [disabled]="saving"
                                                            (click)="
                                                                changeFinalStatus(PlanningStatus.PlanningBevestigd)
                                                            "
                                                            mat-raised-button>
                                                            Bevestigen
                                                        </button>
                                                    } @else {
                                                        <button
                                                            class="status-button status-button-definitief"
                                                            [disabled]="saving"
                                                            (click)="
                                                                changeFinalStatus(PlanningStatus.PlanningDefinitief)
                                                            "
                                                            mat-raised-button>
                                                            Terug naar definitief
                                                        </button>
                                                    }
                                                }
                                            </div>
                                        </div>
                                    }
                                    <ng-select
                                        class="ng-select-fill project-selection"
                                        #projectSelect
                                        [typeahead]="searchAfasProjects$"
                                        [clearable]="true"
                                        [selectableGroup]="false"
                                        [items]="projects"
                                        (focus)="focusProjectSelect()"
                                        (ngModelChange)="afasProjectChange($event)"
                                        (close)="afasProjectClose()"
                                        formControlName="worknumber"
                                        placeholder="Project"
                                        groupBy="mainProject"
                                        bindLabel="name"
                                        bindValue="afas_project_id">
                                        <ng-template ng-label-tmp let-item="item">
                                            <b>{{ item.afas_project_id }}</b> {{ item.name }}
                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item" let-index="index">
                                            <b>{{ item.afas_project_id }}</b> {{ item.name }}
                                        </ng-template>
                                    </ng-select>
                                    @if (viewModel.contractor) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>Opdrachtgever</mat-label>
                                            <input
                                                [matAutocomplete]="autoContractors"
                                                formControlName="contractor"
                                                matInput
                                                placeholder="Opdrachtgever"
                                                type="text" />
                                            <mat-autocomplete #autoContractors="matAutocomplete" autoActiveFirstOption>
                                                @for (val of autocompleteContractors; track val) {
                                                    <mat-option [value]="val">
                                                        {{ val }}
                                                    </mat-option>
                                                }
                                            </mat-autocomplete>
                                            <mat-error [control]="form.get('contractor')"></mat-error>
                                        </mat-form-field>
                                    }
                                    <app-location-select
                                        [control]="$any(form.get('location'))"
                                        (addressSelected)="addressSelected($event)"
                                        source="PlanningDetailDialogComponent.location"
                                        resultFilter="streetAndLocality">
                                    </app-location-select>
                                    @if (viewModel.cutter) {
                                        <ng-container formGroupName="cutter">
                                            <mat-form-field appearance="fill">
                                                <mat-label>Frees</mat-label>
                                                <mat-select formControlName="cutter" placeholder="Frees">
                                                    @for (cutter of cutterList; track cutter) {
                                                        <mat-option
                                                            [disabled]="cutter.notAvailable"
                                                            [value]="cutter.id">
                                                            {{ cutter.name }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                                <mat-error [control]="form.get('cutter').get('cutter')"></mat-error>
                                            </mat-form-field>
                                        </ng-container>
                                    }
                                    @if (viewModel.projectteam) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>Projectteam</mat-label>
                                            <mat-select formControlName="projectteam" placeholder="Ploeg">
                                                @for (team of projectteamList; track team) {
                                                    <mat-option [disabled]="team.notAvailable" [value]="team.id">{{
                                                        team.name
                                                    }}</mat-option>
                                                }
                                            </mat-select>
                                            <mat-error [control]="form.get('projectteam')"></mat-error>
                                        </mat-form-field>
                                    }
                                    @if (viewModel.asfaltteam) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>Ploeg</mat-label>
                                            <mat-select formControlName="asfaltteam" placeholder="Ploeg">
                                                @for (team of asfaltTeamList; track team) {
                                                    <mat-option [disabled]="team.notAvailable" [value]="team.id">
                                                        {{ team.name }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            <mat-error [control]="form.get('asfaltteam')"></mat-error>
                                        </mat-form-field>
                                    }
                                    @if (viewModel.preparationteam) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>Ploeg</mat-label>
                                            <mat-select formControlName="preparationteam" placeholder="Ploeg">
                                                @for (team of preparationTeamList; track team) {
                                                    <mat-option [disabled]="team.notAvailable" [value]="team.id">
                                                        {{ team.name }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            <mat-error [control]="form.get('preparationteam')"></mat-error>
                                        </mat-form-field>
                                    }
                                    @if (viewModel.dumpers && form.get('dumpers').disabled) {
                                        <div class="hidden-details">
                                            <div class="title">Dumpers</div>
                                            @for (dumper of origPlanning.planning_dumpers; track dumper) {
                                                <div>
                                                    <div [matTooltip]="dumper.entity?.name">
                                                        {{ dumper.entity?.name ?? dumper.entity_id }}
                                                    </div>
                                                    <div class="time">
                                                        @if (
                                                            Utils.getDateDate(dumper.begindate) !==
                                                            Utils.getDateDate(mainPlanning.begindate)
                                                        ) {
                                                            {{ dumper.begindate | date: 'EEE' }}
                                                        }
                                                        {{ dumper.begindate | date: 'HH:mm' }}-{{
                                                            dumper.enddate | date: 'HH:mm'
                                                        }}
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                    @if (viewModel.dumpers && !form.get('dumpers').disabled) {
                                        <mat-form-field [matTooltip]="dumperListString" appearance="fill">
                                            <mat-label>Dumpers</mat-label>
                                            <mat-select
                                                formControlName="dumpers"
                                                multiple
                                                placeholder="Selecteer dumpers"
                                                panelWidth="400px">
                                                @for (dumper of dumperList; track dumper) {
                                                    <mat-option
                                                        [disabled]="dumper.notAvailable && !dumper.usedHere"
                                                        [value]="dumper.id">
                                                        {{ dumper.name }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            <mat-error [control]="form.get('dumpers')"></mat-error>
                                        </mat-form-field>
                                    }
                                </div>
                                <div class="form-line">
                                    <ng-container formGroupName="date">
                                        <mat-form-field
                                            class="date"
                                            appearance="fill"
                                            matTooltip="{{
                                                form.get('date')?.get('date')?.value | date: 'EEEE d MMM'
                                            }}">
                                            <mat-label>Datum</mat-label>
                                            <input
                                                [matDatepicker]="pickerStart"
                                                [matDatepickerFilter]="dateFilter"
                                                (focus)="pickerStart.open()"
                                                formControlName="date"
                                                matInput
                                                placeholder="Datum"
                                                tabindex="-1" />
                                            <mat-datepicker-toggle
                                                [for]="pickerStart"
                                                matSuffix></mat-datepicker-toggle>
                                            <mat-error [control]="form.get('date')?.get('date')"></mat-error>
                                            <mat-datepicker #pickerStart></mat-datepicker>
                                        </mat-form-field>
                                        <div class="timepicker">
                                            <mat-form-field
                                                appearance="fill"
                                                matTooltip="van {{
                                                    form.get('date')?.get('begintime')?.value | date: 'HH:mm'
                                                }} tot {{ form.get('date')?.get('endtime')?.value | date: 'HH:mm' }}">
                                                <mat-label>Van</mat-label>
                                                <mat-select
                                                    formControlName="begintime"
                                                    placeholder="van"
                                                    panelWidth="180px">
                                                    @if (startTimes) {
                                                        @for (day of startTimes; track day.datetime) {
                                                            <mat-optgroup
                                                                label="{{ day.datetime | date: 'EEEE d MMM' }}">
                                                                @for (time of day.options; track time) {
                                                                    <mat-option
                                                                        [disabled]="time.notAvailable"
                                                                        [value]="time.time">
                                                                        {{ time.datetime | date: 'HH:mm' }} uur
                                                                    </mat-option>
                                                                }
                                                            </mat-optgroup>
                                                        }
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                            <mat-form-field
                                                appearance="fill"
                                                matTooltip="van {{
                                                    form.get('date')?.get('begintime')?.value | date: 'HH:mm'
                                                }} tot {{ form.get('date')?.get('endtime')?.value | date: 'HH:mm' }}">
                                                <mat-label>Tot</mat-label>
                                                <mat-select
                                                    formControlName="endtime"
                                                    placeholder="Tot tijd"
                                                    panelWidth="180px">
                                                    @if (endTimes) {
                                                        @for (day of endTimes; track day.datetime) {
                                                            <mat-optgroup
                                                                label="{{ day.datetime | date: 'EEEE d MMM' }}">
                                                                @for (time of day.options; track time) {
                                                                    <mat-option
                                                                        [disabled]="time.notAvailable"
                                                                        [value]="time.time">
                                                                        {{ time.datetime | date: 'HH:mm' }} uur
                                                                    </mat-option>
                                                                }
                                                            </mat-optgroup>
                                                        }
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </ng-container>
                                    @if (viewModel.performer) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>{{ environment.executorName }}</mat-label>
                                            <mat-select
                                                [placeholder]="environment.executorName | ucFirst"
                                                formControlName="performer">
                                                @if (
                                                    usersMap?.has(planning.performer) &&
                                                    usersMap?.get(planning.performer).deleted_at
                                                ) {
                                                    <mat-option [value]="usersMap.get(planning.performer).id">
                                                        {{ usersMap.get(planning.performer).name }}
                                                    </mat-option>
                                                }
                                                @for (executor of executors; track executor) {
                                                    <mat-option [value]="executor.id">{{ executor.name }}</mat-option>
                                                }
                                            </mat-select>
                                            <mat-error [control]="form.get('performer')"></mat-error>
                                        </mat-form-field>
                                    }
                                    @if (viewModel.cutter) {
                                        <mat-form-field appearance="fill" formGroupName="cutter">
                                            <mat-label>Ontvangst</mat-label>
                                            <input
                                                formControlName="location"
                                                matInput
                                                placeholder="Ontvangst"
                                                type="text" />
                                            <mat-error [control]="form.get('cutter').get('location')"></mat-error>
                                        </mat-form-field>
                                    }
                                    @if (viewModel.projectmanager) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>Projectleider</mat-label>
                                            <mat-select formControlName="projectmanager" placeholder="Projectleider">
                                                @if (
                                                    usersMap?.has(planning.projectmanager) &&
                                                    usersMap?.get(planning.projectmanager).deleted_at
                                                ) {
                                                    <mat-option [value]="usersMap.get(planning.projectmanager).id">
                                                        {{ usersMap.get(planning.projectmanager).name }}
                                                    </mat-option>
                                                }
                                                @for (projectManager of projectManagers; track projectManager) {
                                                    <mat-option [value]="projectManager.id">{{
                                                        projectManager.name
                                                    }}</mat-option>
                                                }
                                            </mat-select>
                                            <mat-error [control]="form.get('projectmanager')"></mat-error>
                                        </mat-form-field>
                                    }
                                    @if (viewModel.asphalt_performer) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>Asfaltuitvoerder</mat-label>
                                            <mat-select
                                                formControlName="asphalt_performer"
                                                placeholder="Asfaltuitvoerder">
                                                @if (
                                                    usersMap?.has(planning.asphalt_performer) &&
                                                    usersMap.get(planning.asphalt_performer).deleted_at
                                                ) {
                                                    <mat-option [value]="usersMap.get(planning.asphalt_performer).id">
                                                        {{ usersMap.get(planning.asphalt_performer).name }}
                                                    </mat-option>
                                                }
                                                @for (asphaltExecutor of asphaltExecutors; track asphaltExecutor) {
                                                    <mat-option [value]="asphaltExecutor.id">
                                                        {{ asphaltExecutor.name }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            <mat-error [control]="form.get('asphalt_performer')"></mat-error>
                                        </mat-form-field>
                                    }
                                </div>
                                <div class="form-line">
                                    @if (viewModel.wipetruck && viewModel.driver_user_id) {
                                        <ng-container formGroupName="wipetruck">
                                            <mat-form-field appearance="fill">
                                                <mat-label>Machinist</mat-label>
                                                <mat-select formControlName="driver_user_id" placeholder="Machinist">
                                                    @if (
                                                        usersMap?.has(mainPlanning.driver_user_id) &&
                                                        usersMap.get(mainPlanning.driver_user_id).deleted_at
                                                    ) {
                                                        <mat-option
                                                            [value]="usersMap.get(mainPlanning.driver_user_id).id">
                                                            {{ usersMap.get(mainPlanning.driver_user_id).name }}
                                                        </mat-option>
                                                    }
                                                    @for (driver of drivers; track driver) {
                                                        <mat-option [value]="driver.id">{{ driver.name }}</mat-option>
                                                    }
                                                </mat-select>
                                                <mat-error
                                                    [control]="form.get('wipetruck').get('driver_user_id')"></mat-error>
                                                @if (mainPlanning['driver']) {
                                                    <mat-hint>{{ mainPlanning['driver'] }}</mat-hint>
                                                }
                                            </mat-form-field>
                                        </ng-container>
                                    }
                                    @if (viewModel.traffic) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>Verkeersmaatregelen</mat-label>
                                            <mat-select formControlName="traffic" placeholder="Verkeersmaatregelen">
                                                <mat-option value="Verkeersbus">Verkeersbus</mat-option>
                                                <mat-option value="Verkeersplan">Verkeersplan</mat-option>
                                                <mat-option value="Verkeersplan + Verkeersbus"
                                                    >Verkeersplan + Verkeersbus</mat-option
                                                >
                                                <mat-option value="Geen maatregelen">Geen maatregelen</mat-option>
                                            </mat-select>
                                            <mat-error [control]="form.get('traffic')"></mat-error>
                                        </mat-form-field>
                                    }
                                    @if (viewModel.traffic_controllers) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>Aantal verkeersregelaars</mat-label>
                                            <input
                                                appDecimalInput
                                                autocomplete="off"
                                                formControlName="traffic_controllers"
                                                matInput
                                                type="text" />
                                            <mat-error [control]="form.get('traffic_controllers')"></mat-error>
                                        </mat-form-field>
                                    }
                                    @if (viewModel.cutter) {
                                        <ng-container formGroupName="cutter">
                                            <mat-form-field appearance="fill">
                                                <mat-label>Tonnen</mat-label>
                                                <input
                                                    appDecimalInput
                                                    formControlName="tons"
                                                    matInput
                                                    placeholder="Tonnen"
                                                    type="text" />
                                                <mat-error [control]="form.get('cutter').get('tons')"></mat-error>
                                            </mat-form-field>
                                            <mat-form-field appearance="fill">
                                                <mat-label>Vrachtwagens</mat-label>
                                                <input
                                                    appDecimalInput
                                                    formControlName="trucks"
                                                    matInput
                                                    placeholder="Vrachtwagens"
                                                    type="text" />
                                                <mat-error [control]="form.get('cutter').get('trucks')"></mat-error>
                                            </mat-form-field>
                                            @if (!entitiesMap.get(form.get('cutter').get('cutter').value).use_once) {
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Inhuur</mat-label>
                                                    <mat-select formControlName="hiring_id" placeholder="Inhuur">
                                                        @for (hiring of hiringList; track hiring) {
                                                            <mat-option [value]="hiring.id">
                                                                {{ hiring.name }}
                                                            </mat-option>
                                                        }
                                                    </mat-select>
                                                </mat-form-field>
                                            }
                                        </ng-container>
                                    }
                                    @if (viewModel.pouring_off) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>Afgieten</mat-label>
                                            <input
                                                [matAutocomplete]="pouring_off"
                                                formControlName="pouring_off"
                                                matInput
                                                placeholder="Afgieten"
                                                type="text" />
                                            <mat-autocomplete #pouring_off="matAutocomplete" autoActiveFirstOption>
                                                @for (val of autocompletePouringOff; track val) {
                                                    <mat-option [value]="val">
                                                        {{ val }}
                                                    </mat-option>
                                                }
                                            </mat-autocomplete>
                                            <mat-error [control]="form.get('pouring_off')"></mat-error>
                                        </mat-form-field>
                                    }
                                    @if (viewModel.scatter) {
                                        <mat-form-field appearance="fill">
                                            <mat-label>Afstrooien</mat-label>
                                            <mat-select formControlName="scatter" placeholder="Afstrooien">
                                                <mat-option [value]="true">Ja</mat-option>
                                                <mat-option [value]="false">Nee</mat-option>
                                            </mat-select>
                                            <mat-error [control]="form.get('scatter')"></mat-error>
                                        </mat-form-field>
                                    }
                                    @if (viewModel.cranes) {
                                        <mat-form-field [matTooltip]="craneListString" appearance="fill">
                                            <mat-label>Mobiele kraan</mat-label>
                                            <mat-select formControlName="mobile_crane" placeholder="Mobiele kraan">
                                                <mat-option [value]="true">Ja</mat-option>
                                                <mat-option [value]="false">Nee</mat-option>
                                            </mat-select>
                                            <mat-error [control]="form.get('mobile_crane')"></mat-error>
                                        </mat-form-field>
                                    }
                                    <mat-form-field>
                                        <mat-label>Bewonersbrief</mat-label>
                                        <mat-select formControlName="resident_letter">
                                            <mat-option value="Ja">Ja</mat-option>
                                            <mat-option value="Nee">Nee</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            @if (!viewModel.sleepOrBlock) {
                                <div class="col col-md-16 pr-md-0">
                                    <div class="form-line">
                                        @if (viewModel.wipetruck) {
                                            <ng-container formGroupName="wipetruck">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Type vzw</mat-label>
                                                    <input
                                                        [matAutocomplete]="typeAutocomplete"
                                                        type="text"
                                                        placeholder="Type veeg- zuigwagen"
                                                        aria-label="Type veeg- zuigwagen"
                                                        matInput
                                                        formControlName="type" />
                                                    <mat-autocomplete
                                                        #typeAutocomplete="matAutocomplete"
                                                        autoActiveFirstOption>
                                                        <mat-option value="RAVO">RAVO</mat-option>
                                                        <mat-option value="RAVO 3e borstel">RAVO 3e borstel</mat-option>
                                                        <mat-option value="RAVO rolbezem">RAVO rolbezem</mat-option>
                                                        <mat-option value="RAVO reiniger">RAVO reiniger</mat-option>
                                                        <mat-option value="VZW klein">VZW klein</mat-option>
                                                        <mat-option value="VZW rolbezem">VZW rolbezem</mat-option>
                                                        <mat-option value="VZW groot rolbezem"
                                                            >VZW groot rolbezem</mat-option
                                                        >
                                                        <mat-option value="VZW-WDR">VZW-WDR</mat-option>
                                                        <mat-option value="VZW-WDR rolbezem"
                                                            >VZW-WDR rolbezem</mat-option
                                                        >
                                                    </mat-autocomplete>
                                                    <mat-error
                                                        [control]="form.get('wipetruck').get('type')"></mat-error>
                                                </mat-form-field>
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Zuig/-veegwagen</mat-label>
                                                    <mat-select
                                                        formControlName="wipetruck"
                                                        placeholder="Zuig/-veegwagen">
                                                        @for (wipetruck of wipetruckList; track wipetruck) {
                                                            <mat-option
                                                                [disabled]="wipetruck.notAvailable"
                                                                [value]="wipetruck.id"
                                                                >{{ wipetruck.name }}
                                                            </mat-option>
                                                        }
                                                    </mat-select>
                                                    <mat-error
                                                        [control]="form.get('wipetruck').get('wipetruck')"></mat-error>
                                                </mat-form-field>
                                            </ng-container>
                                        }
                                        @if (viewModel.cutter) {
                                            <ng-container formGroupName="cutter">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Dikte</mat-label>
                                                    <input
                                                        appDecimalInput
                                                        formControlName="thickness"
                                                        matInput
                                                        placeholder="Dikte"
                                                        type="text" />
                                                    <mat-error
                                                        [control]="form.get('cutter').get('thickness')"></mat-error>
                                                </mat-form-field>
                                            </ng-container>
                                        }
                                        @if (viewModel.cutter && viewModel.driver_user_id) {
                                            <ng-container formGroupName="cutter">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Machinist</mat-label>
                                                    <mat-select
                                                        formControlName="driver_user_id"
                                                        placeholder="Machinist">
                                                        @if (
                                                            usersMap?.has(mainPlanning.driver_user_id) &&
                                                            usersMap.get(mainPlanning.driver_user_id).deleted_at
                                                        ) {
                                                            <mat-option
                                                                [value]="usersMap.get(mainPlanning.driver_user_id).id">
                                                                {{ usersMap.get(mainPlanning.driver_user_id).name }}
                                                            </mat-option>
                                                        }
                                                        @for (driver of drivers; track driver) {
                                                            <mat-option [value]="driver.id">{{
                                                                driver.name
                                                            }}</mat-option>
                                                        }
                                                    </mat-select>
                                                    <mat-error
                                                        [control]="
                                                            form.get('cutter').get('driver_user_id')
                                                        "></mat-error>
                                                </mat-form-field>
                                                @if (
                                                    !entitiesMap.get(form.get('cutter').get('cutter').value).use_once
                                                ) {
                                                    <mat-form-field appearance="fill">
                                                        <mat-label>Inhuur naam</mat-label>
                                                        <input
                                                            formControlName="name"
                                                            matInput
                                                            placeholder="Inhuur naam"
                                                            type="text" />
                                                        <mat-error [control]="form.get('name')"></mat-error>
                                                    </mat-form-field>
                                                }
                                            </ng-container>
                                        }
                                        @if (viewModel.asphalt_location) {
                                            <mat-form-field [matTooltip]="planning?.asphalt_location" appearance="fill">
                                                <mat-label>Asfaltlocatie</mat-label>
                                                <input
                                                    formControlName="asphalt_location"
                                                    matInput
                                                    placeholder="Asfaltlocatie"
                                                    type="text" />
                                                <mat-error [control]="form.get('asphalt_location')"></mat-error>
                                            </mat-form-field>
                                        }
                                        @if (viewModel.asphaltOthers && form.get('asphalt_others').disabled) {
                                            <div class="hidden-details">
                                                <div class="title">GM Asfalt overig</div>
                                                @for (
                                                    asphaltOther of origPlanning.planning_asphalt_others;
                                                    track asphaltOther
                                                ) {
                                                    <div>
                                                        <div [matTooltip]="asphaltOther.entity?.name">
                                                            {{ asphaltOther.entity?.name ?? asphaltOther.entity_id }}
                                                        </div>
                                                        <div class="time">
                                                            @if (
                                                                Utils.getDateDate(asphaltOther.begindate) !==
                                                                Utils.getDateDate(mainPlanning.begindate)
                                                            ) {
                                                                {{ asphaltOther.begindate | date: 'EEE' }}
                                                            }
                                                            {{ asphaltOther.begindate | date: 'HH:mm' }}-{{
                                                                asphaltOther.enddate | date: 'HH:mm'
                                                            }}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        @if (viewModel.asphaltOthers && !form.get('asphalt_others').disabled) {
                                            <mat-form-field [matTooltip]="otherString" appearance="fill">
                                                <mat-label>GM Asfalt overig</mat-label>
                                                <mat-select
                                                    formControlName="asphalt_others"
                                                    multiple
                                                    placeholder="Selecteer GM asfalt overig"
                                                    panelWidth="400px">
                                                    @for (equipment of asphaltOtherList; track equipment) {
                                                        <mat-option
                                                            [disabled]="equipment.notAvailable && !equipment.usedHere"
                                                            [value]="equipment.id">
                                                            {{ equipment.name }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                                @if (form.get('hotbox').value !== null) {
                                                    <mat-hint>
                                                        Oude waarde hotbox:
                                                        {{ form.get('hotbox').value ? 'Ja' : 'Nee' }}
                                                    </mat-hint>
                                                }
                                                <mat-error [control]="form.get('asphalt_others')"></mat-error>
                                            </mat-form-field>
                                        }
                                        @if (viewModel.rollers && !form.get('rollers').disabled) {
                                            <mat-form-field [matTooltip]="rollerListString" appearance="fill">
                                                <mat-label>Walsen</mat-label>
                                                <mat-select
                                                    formControlName="rollers"
                                                    multiple
                                                    placeholder="Selecteer walsen"
                                                    panelWidth="400px">
                                                    @for (roller of rollerList; track roller) {
                                                        <mat-option
                                                            [disabled]="roller.notAvailable && !roller.usedHere"
                                                            [value]="roller.id">
                                                            {{ roller.name }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                                <mat-error [control]="form.get('rollers')"></mat-error>
                                            </mat-form-field>
                                        }
                                        @if (viewModel.rollers && form.get('rollers').disabled) {
                                            <div class="hidden-details">
                                                <div class="title">Walsen</div>
                                                @for (roller of origPlanning.planning_rollers; track roller) {
                                                    <div>
                                                        <div [matTooltip]="roller.entity?.name">
                                                            {{ roller.entity?.name ?? roller.entity_id }}
                                                        </div>
                                                        <div class="time">
                                                            @if (
                                                                Utils.getDateDate(roller.begindate) !==
                                                                Utils.getDateDate(mainPlanning.begindate)
                                                            ) {
                                                                {{ roller.begindate | date: 'EEE' }}
                                                            }
                                                            {{ roller.begindate | date: 'HH:mm' }}-{{
                                                                roller.enddate | date: 'HH:mm'
                                                            }}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                    <div class="form-line">
                                        @if (viewModel.hire_people) {
                                            <mat-form-field (click)="hirePeopleSelector()" appearance="fill">
                                                <mat-label>Inhuur mensen</mat-label>
                                                <input
                                                    class="blocked-input"
                                                    [disabled]="viewModel.formDisabled"
                                                    (keydown)="$event.preventDefault()"
                                                    matInput
                                                    value="{{
                                                        planning.planning_hire_people
                                                            | PlanningEntitiesToString: entitiesMap
                                                    }}"
                                                    placeholder="Inhuur mensen" />
                                                <mat-error [control]="form.get('hire_people')"></mat-error>
                                                <mat-icon matSuffix>arrow_drop_down</mat-icon>
                                            </mat-form-field>
                                        }
                                        @if (viewModel.sticky_wagons) {
                                            <mat-form-field [matTooltip]="stickyWagonString" appearance="fill">
                                                <mat-label>Kleefwagen</mat-label>
                                                <mat-select formControlName="sticky_wagon" placeholder="Kleefwagen">
                                                    <mat-option value="geen">Geen</mat-option>
                                                    <mat-option value="klein">Klein</mat-option>
                                                    <mat-option value="groot">Groot</mat-option>
                                                </mat-select>
                                                <mat-error [control]="form.get('sticky_wagon')"></mat-error>
                                            </mat-form-field>
                                        }
                                        @if (viewModel.set && form.get('sets').disabled) {
                                            <div class="hidden-details">
                                                <div class="title">Sets</div>
                                                @for (set of origPlanning.planning_sets; track set) {
                                                    <div>
                                                        <div [matTooltip]="set.entity?.name">
                                                            {{ set.entity?.name ?? set.entity_id }}
                                                        </div>
                                                        <div class="time">
                                                            @if (
                                                                Utils.getDateDate(set.begindate) !==
                                                                Utils.getDateDate(mainPlanning.begindate)
                                                            ) {
                                                                {{ set.begindate | date: 'EEE' }}
                                                            }
                                                            {{ set.begindate | date: 'HH:mm' }}-{{
                                                                set.enddate | date: 'HH:mm'
                                                            }}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        @if (viewModel.set && !form.get('sets').disabled) {
                                            <mat-form-field [matTooltip]="setListString" appearance="fill">
                                                <mat-label>Sets</mat-label>
                                                <mat-select
                                                    formControlName="sets"
                                                    multiple
                                                    placeholder="Selecteer sets"
                                                    panelWidth="400px">
                                                    @for (set of setList; track set) {
                                                        <mat-option
                                                            [disabled]="set.notAvailable && !set.usedHere"
                                                            [value]="set.id">
                                                            @if (set.outOfService) {
                                                                <b>(Uit dienst)</b>
                                                            }
                                                            {{ set.name }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                                <mat-error [control]="form.get('sets')"></mat-error>
                                            </mat-form-field>
                                        }
                                    </div>
                                </div>
                            }
                            <div class="col-24 col-md-8">
                                <mat-form-field class="comment-field w-100 h-100" appearance="fill">
                                    <mat-label>Omschrijving</mat-label>
                                    <textarea
                                        formControlName="description"
                                        matInput
                                        placeholder="Omschrijving"
                                        rows="5"></textarea>
                                    <mat-error [control]="form.get('description')"></mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </form>
                }
            </div>
            <div class="bottom-form">
                @if (viewModel.asfaltteam) {
                    <div>
                        <h5>Asfaltleverantie</h5>
                        @if (form) {
                            <app-asphalt-list
                                [formsDisabled]="viewModel.asphaltFormDisabled"
                                [mainPlanning]="mainPlanning"
                                [planningAsphaltList]="planning.asphalt_list"
                                [planning]="planning"></app-asphalt-list>
                        }
                    </div>
                }
                @if (viewModel.cutterList) {
                    <div>
                        <h5>Frezen</h5>
                        @if (form) {
                            <app-cutter-list
                                [formsDisabled]="viewModel.entitiesDisabled"
                                [mainPlanning]="mainPlanning"
                                [fixedDate]="fixedDate"
                                [planningEntitiesList]="planning.planning_cutters"
                                [planning]="planning"></app-cutter-list>
                        }
                    </div>
                }
                @if (viewModel.wipertruckList) {
                    <div>
                        <h5>Veeg-/zuigwagens</h5>
                        @if (form) {
                            <app-wipetruck-list
                                [formsDisabled]="viewModel.entitiesDisabled"
                                [mainPlanning]="mainPlanning"
                                [fixedDate]="fixedDate"
                                [planningEntitiesList]="planning.planning_wipetrucks"
                                [planning]="planning"></app-wipetruck-list>
                        }
                    </div>
                }
                @if (leave || planning.status_key == PlanningStatus.PlanningSlaapdag) {
                    <div>
                        @if (leave && users) {
                            <ng-select
                                [(ngModel)]="leave.users"
                                [disabled]="viewModel.formDisabled"
                                [items]="users"
                                [clearable]="true"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                appendTo="body"
                                placeholder="Medewerkers"
                                bindLabel="name">
                            </ng-select>
                        }
                    </div>
                }
                @if (viewModel.showUserPlanning) {
                    <div class="mt-2">
                        <app-planning-detail-employees
                            [planning]="planning"
                            [planningForm]="form"
                            [formsDisabled]="viewModel.employeeDisabled"></app-planning-detail-employees>
                    </div>
                }
            </div>
        </div>
    }
</div>
<div class="d-flex flex-wrap pt-2 pb-2" mat-dialog-actions>
    @if ((Features.PlanningDetailDelete | hasFeature) && planning.id && !viewModel.entitiesDisabled) {
        <button (click)="delete()" color="warn" color="warn" mat-button>Verwijderen</button>
    }
    @if (planning.id && (Features.PlanningSave | hasFeature)) {
        <button [disabled]="form?.dirty" (click)="copy()" color="warn" color="secondary" mat-button>
            Kopi&euml;ren
        </button>
    }
    @if (planning.id) {
        <button (click)="print()" color="warn" color="secondary" mat-button>Printen</button>
    }
    @if ((Features.PlanningDetailHistory | hasFeature) && planning.id && environment.platform !== 'buitengewoonbv') {
        <button [disabled]="saving || loadingHistory" (click)="openHistory()" color="secondary" mat-button>
            {{ loadingHistory ? 'Historie wordt geladen...' : 'Historie' }}
        </button>
    }
    @if ((leave || planning.status_key == PlanningStatus.PlanningSlaapdag) && !viewModel.formDisabled) {
        <button (click)="updateLeave(true)" mat-button>Verlof bijwerken</button>
    }
    @if (externalChanged) {
        <div class="fixed-date-message">
            Deze planning is vanaf een ander apparaat aangepast. Open de planning opnieuw om wijzigingen aan te brengen.
        </div>
    }
    @if (fixedDate && !externalChanged) {
        <div class="fixed-date-message">
            Dit item kan alleen door een materieelplanner worden aangepast omdat de planning is vastgezet tot
            {{ fixedDate | date: 'EEEE d MMMM yyyy' }}.
        </div>
    }
    @if (viewModel.formDisabled && !fixedDate && !externalChanged) {
        <div class="fixed-date-message">
            Dit item kan alleen door een materieelplanner en
            {{ usersMap.get(planning.projectmanager)?.name }}
            worden aangepast.
        </div>
    }
    <div class="spacer"></div>
    <button class="me-2" (click)="close()" color="accent" mat-raised-button>
        {{ viewModel.formDisabled ? 'Sluiten' : 'Annuleren' }}
    </button>
    @if (!externalChanged && (!viewModel.formDisabled || !viewModel.asphaltFormDisabled)) {
        <button [disabled]="saving" (click)="save()" color="primary" mat-raised-button>
            {{ saving ? 'Valideren & opslaan...' : 'Opslaan' }}
            @if (saving) {
                <i class="fas fa-circle-notch fa-spin"></i>
            }
        </button>
    }
</div>
